export const createStringNumsArray = (from: number, to: number) => {
    const arr: Array<string> = [];
    for (let i = from; i <= to; i++) {
        arr.push(i.toString());
    }

    return arr;
};
